import React, { useState, useEffect } from "react";
import { CheckBox } from "./CheckBox";  // Asume que CheckBox y useChecked están en el mismo directorio
import { RadioButtonGroup } from "./RadioButtonGroup"; // Importa el componente de radio

export const FilterCheckboxGroup = ({
                                        title = "Languages Spoken",
                                        data = [], // Datos de checkboxes
                                        type = "checkbox", // Puede ser 'checkbox' o 'radio'
                                        selectedItems = [], // Lista de slugs seleccionados inicialmente
                                        setSelectedItems
                                    }) => {
    // Inicialización del estado para checkboxes
    const initialState = data.reduce((acc, { slug }) => {
        acc[slug] = false; // Inicializa todos los checkboxes en 'false'
        return acc;
    }, {});


    const [checked, setChecked] = useState(initialState);
    const [selectedRadio, setSelectedRadio] = useState(selectedItems[0]); // Estado para el radio

    useEffect(() => {
        if (type === "checkbox") {
            if (selectedItems.length === 0) {
                setChecked(initialState);
            } else {
                const newChecked = data.reduce((acc, { slug }) => {
                    acc[slug] = selectedItems.includes(slug);
                    return acc;
                }, {});
                setChecked(newChecked);
            }
        } else if (type === "radio") {
            // Solo actualiza si el valor viene de fuera y no coincide
            if (selectedItems[0] !== selectedRadio) {
                setSelectedRadio(selectedItems[0] || "");
            }
        }
    }, [selectedItems, data]);


    // Función para manejar el cambio de selección (checkbox)
    const handleClickCheckedBox = ({ target }) => {
        const newChecked = {
            ...checked,
            [target.name]: !checked[target.name],
        };

        setChecked(newChecked);

        // Calcula los seleccionados a partir del nuevo estado
        const updatedSelected = Object.keys(newChecked).filter((key) => newChecked[key]);
        setSelectedItems(updatedSelected);
    };

    // Función para manejar el cambio de selección (solo para radio)
    const handleRadioChange = (slug) => {
        setSelectedRadio(slug);
        setSelectedItems([slug]); // Reemplaza el array con el slug seleccionado
    };

    return (
        <div className="mb-3">
            <p className="fs-6 mb-3">{title}</p>
            <div className="d-flex flex-wrap gap-3">
                {type === "checkbox" ? (
                    data.map(({ slug, value }) => (
                        <div key={slug} className="checkbox-item d-flex align-items-center gap-2">
                            <CheckBox
                                type={type}
                                name={slug}
                                checked={checked[slug] || false}  // Verifica el estado de checked
                                setChecked={handleClickCheckedBox}  // Llamar a la función de toggle
                            />
                            <label className="checkbox-label fw-normal small-text" htmlFor={`${type}-${slug}`}>
                                {value}
                            </label>
                        </div>
                    ))
                ) : (
                    <RadioButtonGroup
                        title={title}
                        data={data}
                        selectedValue={selectedRadio} // Aquí usamos el valor seleccionado para radio
                        setSelectedValue={handleRadioChange} // Pasamos la función de cambio
                    />
                )}
            </div>
        </div>
    );
};

export default FilterCheckboxGroup;
